/** Espelha limites do edge (catalog-routing.ts). */
export const MAX_CATALOG_TRIGGER_PHRASES = 20;
export const MAX_CATALOG_TRIGGER_PHRASE_LEN = 80;

export function normalizeCatalogTriggerPhrases(input: unknown): string[] {
  if (!Array.isArray(input)) return [];
  const seen = new Set<string>();
  const out: string[] = [];
  for (const raw of input) {
    const t = String(raw ?? "").trim();
    if (!t || t.length > MAX_CATALOG_TRIGGER_PHRASE_LEN) continue;
    const key = t.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(t);
    if (out.length >= MAX_CATALOG_TRIGGER_PHRASES) break;
  }
  return out;
}
